"use client";
import React from "react";
import PageLayout from "@/layouts/pageLayout";
// import CatalogIntro from "./components/catalogIntro";
import CatalogPdf from "./components/catalogPdf";

const CatalogPage = () => {
  return (
    <PageLayout showContactForm showCustomers>
      {/* <CatalogIntro /> */}
      <CatalogPdf />
    </PageLayout>
  );
};

export default CatalogPage;
